var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 10.4853,
    height: 10.4853,
    viewBox: "0 0 10.4853 10.4853",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95496 10.0156C9.24785 10.3085 9.72273 10.3085 10.0156 10.0156C10.3085 9.72272 10.3085 9.24784 10.0156 8.95495L6.30333 5.24266L10.0156 1.53037C10.3085 1.23748 10.3085 0.762607 10.0156 0.469714C9.72272 0.176821 9.24784 0.176821 8.95495 0.469714L5.24267 4.182L1.53034 0.46967C1.23745 0.176776 0.762572 0.176777 0.469679 0.46967C0.176786 0.762563 0.176785 1.23744 0.469679 1.53033L4.18201 5.24266L0.46967 8.955C0.176776 9.24789 0.176777 9.72276 0.46967 10.0157C0.762563 10.3085 1.23744 10.3085 1.53033 10.0157L5.24267 6.30332L8.95496 10.0156Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveX);
export default __webpack_public_path__ + "static/media/remove-x.bee98c8ee8868f650c534f08bbe9c920.svg";
export { ForwardRef as ReactComponent };